module.exports = __webpack_public_path__ + "media/trophy/trophy-01-ca6d25f0.svg";